
// // src/components/admin/Sedes.jsx
// import React, { useEffect, useState } from "react";
// import axios from "../../api/axiosAuth";

// import { useAuth } from "../../context/AuthContext";

// export default function Sedes() {
//   const { token, user } = useAuth();
//   const API = process.env.REACT_APP_API || "http://3.236.217.225:5001/api";

//   const [sedes, setSedes] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [form, setForm] = useState({ id: null, nombre: "", direccion: "", telefono: "" });

//   // 🔁 Cargar sedes del tenant autenticado
//   const fetchSedes = async () => {
//     if (!user?.tenant_id) {
//       setLoading(false);
//       return;
//     }
//     try {
//       const res = await axios.get(`${API}/sedes`, {
//         headers: { Authorization: `Bearer ${token}` },
//       });
//       setSedes(res.data || []);
//     } catch (err) {
//       console.warn("No se pudieron cargar las sedes o no hay sedes aún:", err.message);
//       setSedes([]);
//     } finally {
//       setLoading(false);
//     }
//   };

//   useEffect(() => {
//     fetchSedes();
//   }, [token, user?.tenant_id]);

//   // 📝 Crear o actualizar sede
//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     if (!form.nombre.trim()) return alert("El nombre es obligatorio");

//     try {
//       const payload = { nombre: form.nombre, direccion: form.direccion, telefono: form.telefono };

//       if (form.id) {
//         await axios.put(`${API}/sedes/${form.id}`, payload, {
//           headers: { Authorization: `Bearer ${token}` },
//         });
//         alert("✅ Sede actualizada");
//       } else {
//         await axios.post(`${API}/sedes`, payload, {
//           headers: { Authorization: `Bearer ${token}` },
//         });
//         alert("✅ Sede creada");
//       }

//       setForm({ id: null, nombre: "", direccion: "", telefono: "" });
//       fetchSedes();
//     } catch (err) {
//       console.error("❌ Error guardando sede:", err);
//       alert(err.response?.data?.msg || "Error guardando sede");
//     }
//   };

//   // ✏️ Editar sede
//   const handleEdit = (sede) => setForm(sede);

//   // 🗑 Eliminar sede
//   const handleDelete = async (id) => {
//     if (!window.confirm("¿Eliminar esta sede?")) return;
//     try {
//       await axios.delete(`${API}/sedes/${id}`, {
//         headers: { Authorization: `Bearer ${token}` },
//       });
//       alert("✅ Sede eliminada");
//       fetchSedes();
//     } catch (err) {
//       console.error("❌ Error eliminando sede:", err);
//       alert(err.response?.data?.msg || "Error eliminando sede");
//     }
//   };

//   return (
//     <div className="sedes-container">
//       <h2>🏫 Gestión de Sedes</h2>

//       {/* Formulario siempre visible */}
//       <form onSubmit={handleSubmit} className="form-sede">
//         <input
//           type="text"
//           placeholder="Nombre"
//           value={form.nombre}
//           onChange={(e) => setForm({ ...form, nombre: e.target.value })}
//         />
//         <input
//           type="text"
//           placeholder="Dirección"
//           value={form.direccion}
//           onChange={(e) => setForm({ ...form, direccion: e.target.value })}
//         />
//         <input
//           type="text"
//           placeholder="Teléfono"
//           value={form.telefono}
//           onChange={(e) => setForm({ ...form, telefono: e.target.value })}
//         />
//         <button type="submit">{form.id ? "Actualizar" : "Crear"}</button>
//         {form.id && (
//           <button type="button" onClick={() => setForm({ id: null, nombre: "", direccion: "", telefono: "" })}>
//             Cancelar
//           </button>
//         )}
//       </form>

//       {/* Tabla de sedes */}
//       {loading ? (
//         <p>Cargando sedes...</p>
//       ) : sedes.length ? (
//         <table className="table-sedes">
//           <thead>
//             <tr>
//               <th>Nombre</th>
//               <th>Dirección</th>
//               <th>Teléfono</th>
//               <th>Acciones</th>
//             </tr>
//           </thead>
//           <tbody>
//             {sedes.map((s) => (
//               <tr key={s.id}>
//                 <td>{s.nombre}</td>
//                 <td>{s.direccion || "-"}</td>
//                 <td>{s.telefono || "-"}</td>
//                 <td>
//                   <button onClick={() => handleEdit(s)}>Editar</button>
//                   <button onClick={() => handleDelete(s.id)}>Eliminar</button>
//                 </td>
//               </tr>
//             ))}
//           </tbody>
//         </table>
//       ) : (
//         <p>No hay sedes creadas todavía.</p>
//       )}
//     </div>
//   );
// }

import React, { useEffect, useState, useCallback } from "react";
import axios from "../../api/axiosAuth";
import { useAuth } from "../../context/AuthContext";
import { API } from "../config"; 
import "../../style/Sedes.css"; // Asegúrate de crear este archivo

export default function Sedes() {
  const { token, user } = useAuth();

  const [sedes, setSedes] = useState([]);
  const [loading, setLoading] = useState(true);
  const [form, setForm] = useState({ id: null, nombre: "", direccion: "", telefono: "" });

  /* ===============================
      🔄 CARGA DE SEDES
  =============================== */
  const fetchSedes = useCallback(async () => {
    if (!token || !user?.tenant_id) return;

    try {
      setLoading(true);
      const res = await axios.get(`${API}/sedes`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      setSedes(Array.isArray(res.data) ? res.data : res.data.sedes || []);
    } catch (err) {
      console.warn("⚠️ No se pudieron cargar las sedes:", err.message);
      setSedes([]);
    } finally {
      setLoading(false);
    }
  }, [token, user?.tenant_id]);

  useEffect(() => {
    fetchSedes();
  }, [fetchSedes]);

  /* ===============================
      📝 GESTIÓN DE DATOS (CUD)
  =============================== */
  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!form.nombre.trim()) return alert("El nombre de la sede es obligatorio");

    try {
      const payload = { 
        nombre: form.nombre, 
        direccion: form.direccion, 
        telefono: form.telefono,
        tenant_id: user.tenant_id 
      };

      if (form.id) {
        await axios.put(`${API}/sedes/${form.id}`, payload, {
          headers: { Authorization: `Bearer ${token}` },
        });
        alert("✅ Sede actualizada correctamente");
      } else {
        await axios.post(`${API}/sedes`, payload, {
          headers: { Authorization: `Bearer ${token}` },
        });
        alert("✅ Sede creada con éxito");
      }

      setForm({ id: null, nombre: "", direccion: "", telefono: "" });
      fetchSedes();
    } catch (err) {
      console.error("❌ Error al guardar sede:", err);
      alert(err.response?.data?.message || "Error al procesar la solicitud");
    }
  };

  const handleEdit = (sede) => {
    setForm({
      id: sede.id,
      nombre: sede.nombre,
      direccion: sede.direccion || "",
      telefono: sede.telefono || ""
    });
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  const handleDelete = async (id) => {
    if (!window.confirm("¿Estás seguro de eliminar esta sede? Esto podría afectar a los usuarios vinculados.")) return;
    
    try {
      await axios.delete(`${API}/sedes/${id}`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      alert("✅ Sede eliminada");
      fetchSedes();
    } catch (err) {
      console.error("❌ Error al eliminar sede:", err);
      alert(err.response?.data?.message || "No se pudo eliminar la sede");
    }
  };

  return (
    <div className="sedes-container p-6">
      <h2 className="text-2xl font-bold mb-6">🏫 Gestión de Sedes Académicas</h2>

      {/* SECCIÓN FORMULARIO */}
      <div className="bg-white p-6 rounded-lg shadow-md mb-8 border border-gray-100">
        <h3 className="text-lg font-semibold mb-4">
          {form.id ? "✏️ Editar Sede" : "➕ Registrar Nueva Sede"}
        </h3>
        <form onSubmit={handleSubmit} className="grid grid-cols-1 md:grid-cols-4 gap-4">
          <div className="flex flex-col gap-1">
            <input
              className="p-2 border rounded outline-none focus:ring-2 focus:ring-blue-400"
              type="text"
              placeholder="Nombre de la sede"
              value={form.nombre}
              onChange={(e) => setForm({ ...form, nombre: e.target.value })}
              required
            />
          </div>
          <div className="flex flex-col gap-1">
            <input
              className="p-2 border rounded outline-none focus:ring-2 focus:ring-blue-400"
              type="text"
              placeholder="Dirección"
              value={form.direccion}
              onChange={(e) => setForm({ ...form, direccion: e.target.value })}
            />
          </div>
          <div className="flex flex-col gap-1">
            <input
              className="p-2 border rounded outline-none focus:ring-2 focus:ring-blue-400"
              type="text"
              placeholder="Teléfono"
              value={form.telefono}
              onChange={(e) => setForm({ ...form, telefono: e.target.value })}
            />
          </div>
          <div className="flex gap-2">
            <button 
              type="submit" 
              className={`flex-1 py-2 rounded font-bold text-white transition-all active:scale-95 ${form.id ? "bg-orange-500 hover:bg-orange-600" : "bg-blue-600 hover:bg-blue-700"}`}
            >
              {form.id ? "Guardar" : "Crear"}
            </button>
            {form.id && (
              <button 
                type="button" 
                className="px-4 py-2 bg-gray-400 hover:bg-gray-500 text-white rounded transition-all active:scale-95"
                onClick={() => setForm({ id: null, nombre: "", direccion: "", telefono: "" })}
              >
                ✖
              </button>
            )}
          </div>
        </form>
      </div>

      {/* SECCIÓN TABLA */}
      <div className="bg-white rounded-lg shadow-md overflow-hidden border border-gray-200">
        {loading ? (
          <div className="p-10 text-center text-gray-500">
            <div className="spinner mb-2"></div>
            <p>Cargando sedes...</p>
          </div>
        ) : sedes.length > 0 ? (
          <table className="w-full text-left border-collapse table-sedes">
            <thead className="bg-gray-100 border-b">
              <tr>
                <th className="p-4 font-bold text-gray-700">Nombre</th>
                <th className="p-4 font-bold text-gray-700">Dirección</th>
                <th className="p-4 font-bold text-gray-700">Teléfono</th>
                <th className="p-4 font-bold text-gray-700 text-center">Acciones</th>
              </tr>
            </thead>
            <tbody>
              {sedes.map((s) => (
                <tr key={s.id} className="border-b hover:bg-gray-50 transition-colors">
                  <td data-label="Nombre" className="p-4 text-gray-800 font-medium">{s.nombre}</td>
                  <td data-label="Dirección" className="p-4 text-gray-600">{s.direccion || "-"}</td>
                  <td data-label="Teléfono" className="p-4 text-gray-600">{s.telefono || "-"}</td>
                  <td className="p-4 flex justify-center gap-2 acciones-td">
                    <button 
                      onClick={() => handleEdit(s)}
                      className="px-3 py-1 bg-blue-100 text-blue-700 rounded hover:bg-blue-200 transition-colors"
                    >
                      Editar
                    </button>
                    <button 
                      onClick={() => handleDelete(s.id)}
                      className="px-3 py-1 bg-red-100 text-red-700 rounded hover:bg-red-200 transition-colors"
                    >
                      Eliminar
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        ) : (
          <div className="p-10 text-center text-gray-400">
            <p className="text-xl">🏫</p>
            <p>Aún no has registrado sedes.</p>
          </div>
        )}
      </div>
    </div>
  );
}